import { Badge, Box, TableCell, TableHead, TableRow, TableSortLabel } from '@mui/material';
import { visuallyHidden } from '@mui/utils';

const CustomTableHead = ({ columns, styles, orderBy, order, onRequestSort }: any) => {
  return (
    <TableHead
      sx={{
        position: 'sticky',
        top: 0,
        left: 0,
        width: '100%',
        zIndex: '1',
      }}>
      <TableRow>
        {columns.map((i: any, idx: number) => {
          return (
            <TableCell
              key={idx}
              sx={{
                border: 'none',
                fontSize: '14px',
                color: '#000000',
                fontWeight: '600',
                width: i?.width || '100%',
                paddingTop: '13px',
                paddingBottom: '13px',
                userSelect: 'none',
                background: styles?.headBg ? styles?.headBg : '#fff',
                '.MuiTableSortLabel-icon': {
                  display: !i.sort ? 'none' : 'block',
                },
              }}
              sortDirection={orderBy === i.field ? order : false}>
              <TableSortLabel
                active={orderBy === i.field}
                direction={orderBy === i.field ? order : 'asc'}
                onClick={(e) => (i?.modal ? i?.modal(e) : onRequestSort(i.field))}>
                {i?.filter ? (
                  <Badge color='error' variant='dot' sx={{ marginTop: '5px', marginRight: '10px' }}>
                    {i?.icon}
                  </Badge>
                ) : (
                  <span style={{ marginTop: '5px', marginRight: i?.icon ? '10px' : 0 }}>{i?.icon}</span>
                )}
                {i.headerName}
                {orderBy === i.field ? (
                  <Box component='span' sx={visuallyHidden}>
                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                  </Box>
                ) : null}
              </TableSortLabel>
            </TableCell>
          );
        })}
      </TableRow>
    </TableHead>
  );
};

export default CustomTableHead;
